const r = (e, t) => {
  var a;
  return (a = e.data[t]) == null ? void 0 : a.value;
}, l = (e, t) => (e.data[t].value = e.newValue, !0);
export {
  r as IndexBarCellValueGetter,
  l as IndexBarCellValueSetter
};
//# sourceMappingURL=index.es637.js.map
